import { Component, ChangeDetectionStrategy } from '@angular/core';
import packageJson from '../../../../../package.json';
@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrl: './page-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageFooterComponent {
  currentDate: Date = new Date();
  public version?: string;

  constructor() {
    if (packageJson) {
      this.version = packageJson.version;
    }
  }
}
